let localeRu = {
    days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    daysShort: ['ВСК', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
    daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    today: 'Сегодня',
    clear: 'Очистить',
    dateFormat: 'dd.MM.yyyy',
    timeFormat: 'HH:mm',
    firstDay: 1
};

window.addEventListener('DOMContentLoaded', () => {
    fix100vh();
    window.addEventListener('resize', () => {
        fix100vh();
        getScrollBarSize()
    })

    getScrollBarSize()

    let startDate = new Date()

    let dateField = new AirDatepicker('.date-input', {
        locale: localeRu,
        inline: true,
        // isMobile: true,
        autoClose: true,
        startDate: startDate,
        selectedDates: [startDate],
        onSelect: (date) => {
            $(".time-field__date").html(date.formattedDate)
        },

    })

    $(".time-field__date").html(startDate.toLocaleDateString("ru-Ru"))

    $(".time-field").click(function () {
        $(".time").toggleClass("_open")
    })

    $(".hours-picker__item").click(function () {
        $(".hours-picker__item").removeClass("_active")
        $(this).addClass("_active")

        $(".time-field__time").html($(this).attr("data-time"))
    })

    $(".time-field__time").html($(".hours-picker__item._active").attr("data-time"))

    $(".time-modal__btn").click(function () {
        $(".time-field").addClass("_active")
        $(".time").removeClass("_open")
    })

    $(document).mouseup( function(e){
        var div = $( ".time" );
        if ( !div.is(e.target)
            && div.has(e.target).length === 0 ) {
            if($(div).hasClass("_open")){
                $(div).removeClass("_open")
            }
        }
    });
})

function fix100vh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
